import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
// eslint-disable-next-line import/extensions
import "./AddressToLocation.js";

Scrivito.provideEditingConfig("MarkerWidget", {
  title: "Marker",
  attributes: localizeAttrList(["address", "content", "color"], "MarkerWidget"),
  properties: ["headline", "content", "link", "color"],
  propertiesGroups: [
    {
      title: "Marker",
      component: "AddressToLocation",
      key: "addressToLocation",
    },
  ],
  initialContent: {
    address: "",
    color: "blue",
  },
  validations: [
    [
      "address",
      (address) => {
        if (!address || address.trim().length === 0) {
          return {
            message: "Address is required.",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      "lat",
      (lat) => {
        if (!Number.isFinite(lat)) {
          return {
            message:
              "Latitude is required. Enter a valid address and click 'Get Location' to fetch latitude and longitude.",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      "lon",
      (lon) => {
        if (!Number.isFinite(lon)) {
          return {
            message:
              "Longitude is required. Enter a valid address and click 'Get Location' to fetch latitude and longitude.",
            severity: "error",
          };
        }
        return null;
      },
    ],
  ],
});
